import React, { useState, useEffect } from 'react';
import './Referral.css';
import RForm from './referral-agreement-form.pdf';
import { PDFDocument } from 'pdf-lib';
import emailjs from 'emailjs-com';
import { fetchAuthSession, getCurrentUser } from 'aws-amplify/auth';


const Referral = () => {
  const [formData, setFormData] = useState({
    sendingBrokerName: '',
        sendingBrokerLicense: '',
        sendingBrokerSalesperson: '',
        sendingBrokerOffice: '',
        sendingBrokerAddress: '',
        sendingBrokerCity: '',
        sendingBrokerState: '',
        sendingBrokerZip: '',
        sendingBrokerOfficePhone: '',
        sendingBrokerCellPhone: '',
        sendingBrokerFax: '',
        sendingBrokerEmail: '',
        sendingBrokerContactMethod: '',
        sendingBrokerTaxID: '',
        receivingBrokerName: '',
        receivingBrokerLicense: '',
        receivingBrokerSalesperson: '',
        receivingBrokerOffice: '',
        receivingBrokerAddress: '',
        receivingBrokerCity: '',
        receivingBrokerState: '',
        receivingBrokerZip: '',
        receivingBrokerOfficePhone: '',
        receivingBrokerCellPhone: '',
        receivingBrokerFax: '',
        receivingBrokerEmail: '',
        receivingBrokerContactMethod: '',
        receivingBrokerDesignation: '',
        consumerNames: '',
        consumerAddress: '',
        consumerCity: '',
        consumerState: '',
        consumerZip: '',
        propertyAddress: '',
        propertyCity: '',
        propertyState: '',
        propertyZip: '',
        consumerHomePhone: '',
        consumerWorkPhone: '',
        consumerCellPhone: '',
        consumerEmail: '',
        consumerContactMethod: '',
        consumerPermissionYes: false,
        consumerPermissionNo: false,
        referralTypeListing: false,
        referralTypePurchase: false,
        referralTypeLeasing: false,
        referralTypeOther: false,
        referralTypeOtherText: '',
        feeAgreementListing: false,
        feeListingPercent: '',
        feeListingDollar: '',
        feeAgreementPurchase: false,
        feePurchasePercent: '',
        feePurchaseDollar: '',
        feeAgreementLeaseOfConsumer: false,
        feeLeasePropertyPercent: '',
        feeLeasePropertyDollar: '',
        feeAgreementLeaseByConsumer: false,
        feeLeaseByConsumerPercent: '',
        feeLeaseByConsumerDollar: '',
        feeAgreementOther: false,
        feeAgreementOtherText: '',
        feeDaysToPay: '',
        feeDaysValid: '',
        signatureName: '',
        signatureDate: '',
  });

  const [errors, setErrors] = useState('');
  const [successMsg, setSuccessMsg] = useState('');
  const [loading, setLoading] = useState(false);

  const handleFormChange = (e) => {
    const { name, type, value, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const [fullName, setFullName] = useState("");

  useEffect(() => {
    async function loadUser() {
      try {
        const user = await getCurrentUser();
        // fetchAuthSession gives you tokens, which include user attributes
        const session = await fetchAuthSession();
        const idToken = session.tokens?.idToken;
        const name = idToken?.payload?.name;

        setFullName(name || user.username || "User");
      } catch (err) {
        console.error("Error fetching user info:", err);
      }
    }
    loadUser();
  }, []);


const handleSubmit = async (e) => {
  e.preventDefault();
  setLoading(true);
  setErrors('');
  setSuccessMsg('');

  try {
    // 1. Load the template PDF from public folder
    const formUrl = RForm;
    const existingPdfBytes = await fetch(formUrl).then((res) =>
      res.arrayBuffer()
    );

    // 2. Load the PDFDocument
    const pdfDoc = await PDFDocument.load(existingPdfBytes);

    // 3. Get the form fields
    const form = pdfDoc.getForm();

    // 4. Fill form fields (names must match Acrobat field names)
    form.getTextField('sendingBrokerName').setText(formData.sendingBrokerName);
    form.getTextField('sendingBrokerLicense').setText(formData.sendingBrokerLicense);
    form.getTextField('sendingBrokerSalesperson').setText(formData.sendingBrokerSalesperson);
    form.getTextField('sendingBrokerOffice').setText(formData.sendingBrokerOffice);
    form.getTextField('sendingBrokerAddress').setText(formData.sendingBrokerAddress);
    form.getTextField('sendingBrokerCity').setText(formData.sendingBrokerCity);
    form.getTextField('sendingBrokerState').setText(formData.sendingBrokerState);
    form.getTextField('sendingBrokerZip').setText(formData.sendingBrokerZip);
    form.getTextField('sendingBrokerOfficePhone').setText(formData.sendingBrokerOfficePhone);
    form.getTextField('sendingBrokerCellPhone').setText(formData.sendingBrokerCellPhone);
    form.getTextField('sendingBrokerFax').setText(formData.sendingBrokerFax);
    form.getTextField('sendingBrokerEmail').setText(formData.sendingBrokerEmail);
    form.getTextField('sendingBrokerContactMethod').setText(formData.sendingBrokerContactMethod);
    form.getTextField('sendingBrokerTaxID').setText(formData.sendingBrokerTaxID);
    
    form.getTextField('receivingBrokerName').setText(formData.receivingBrokerName);
    form.getTextField('receivingBrokerLicense').setText(formData.receivingBrokerLicense);
    form.getTextField('receivingBrokerSalesperson').setText(formData.receivingBrokerSalesperson);
    form.getTextField('receivingBrokerOffice').setText(formData.receivingBrokerOffice);
    form.getTextField('receivingBrokerAddress').setText(formData.receivingBrokerAddress);
    form.getTextField('receivingBrokerCity').setText(formData.receivingBrokerCity);
    form.getTextField('receivingBrokerState').setText(formData.receivingBrokerState);
    form.getTextField('receivingBrokerZip').setText(formData.receivingBrokerZip);
    form.getTextField('receivingBrokerOfficePhone').setText(formData.receivingBrokerOfficePhone);
    form.getTextField('receivingBrokerCellPhone').setText(formData.receivingBrokerCellPhone);
    form.getTextField('receivingBrokerFax').setText(formData.receivingBrokerFax);
    form.getTextField('receivingBrokerEmail').setText(formData.receivingBrokerEmail);
    form.getTextField('receivingBrokerContactMethod').setText(formData.receivingBrokerContactMethod);
    form.getTextField('receivingBrokerDesignation').setText(formData.receivingBrokerDesignation);
    
    form.getTextField('consumerNames').setText(formData.consumerNames);
    form.getTextField('consumerAddress').setText(formData.consumerAddress);
    form.getTextField('consumerCity').setText(formData.consumerCity);
    form.getTextField('consumerState').setText(formData.consumerState);
    form.getTextField('consumerZip').setText(formData.consumerZip);
    form.getTextField('propertyAddress').setText(formData.propertyAddress);
    form.getTextField('propertyCity').setText(formData.propertyCity);
    form.getTextField('propertyState').setText(formData.propertyState);
    form.getTextField('propertyZip').setText(formData.propertyZip);
    form.getTextField('consumerHomePhone').setText(formData.consumerHomePhone);
    form.getTextField('consumerWorkPhone').setText(formData.consumerWorkPhone);
    form.getTextField('consumerCellPhone').setText(formData.consumerCellPhone);
    form.getTextField('consumerEmail').setText(formData.consumerEmail);
    form.getTextField('consumerContactMethod').setText(formData.consumerContactMethod);
    
    // checkboxes / radio buttons
    if (formData.consumerPermissionYes) {
      form.getCheckBox('consumerPermissionYes').check();
    }
    
    if (formData.consumerPermissionNo) {
      form.getCheckBox('consumerPermissionNo').check();
    }

    if (formData.referralTypeListing) {
      form.getCheckBox('referralTypeListing').check();
    }
    
    if (formData.referralTypePurchase) {
      form.getCheckBox('referralTypePurchase').check();
    }

    if (formData.referralTypeLeasing) {
      form.getCheckBox('referralTypeLeasing').check();
    }
    
    if (formData.referralTypeOther) {
      form.getCheckBox('referralTypeOther').check();
    }
    
    form.getTextField('referralTypeOtherText').setText(formData.referralTypeOtherText);
    
    if (formData.feeAgreementListing) {
      form.getCheckBox('feeAgreementListing').check();
    }

    form.getTextField('feeListingPercent').setText(formData.feeListingPercent);
    form.getTextField('feeListingDollar').setText(formData.feeListingDollar);
    
    if (formData.feeAgreementPurchase) {
      form.getCheckBox('feeAgreementPurchase').check();
    }

    form.getTextField('feePurchasePercent').setText(formData.feePurchasePercent);
    form.getTextField('feePurchaseDollar').setText(formData.feePurchaseDollar);
    
    if (formData.feeAgreementLeaseOfConsumer) {
      form.getCheckBox('feeAgreementLeaseOfConsumer').check();
    }

    form.getTextField('feeLeasePropertyPercent').setText(formData.feeLeasePropertyPercent);
    form.getTextField('feeLeasePropertyDollar').setText(formData.feeLeasePropertyDollar);
    
    if (formData.feeAgreementLeaseByConsumer) {
      form.getCheckBox('feeAgreementLeaseByConsumer').check();
    }

    form.getTextField('feeLeaseByConsumerPercent').setText(formData.feeLeaseByConsumerPercent);
    form.getTextField('feeLeaseByConsumerDollar').setText(formData.feeLeaseByConsumerDollar);
    
    if (formData.feeAgreementOther) {
      form.getCheckBox('feeAgreementOther').check();
    }

    form.getTextField('feeAgreementOtherText').setText(formData.feeAgreementOtherText);
    
    form.getTextField('feeDaysToPay').setText(formData.feeDaysToPay);
    form.getTextField('feeDaysValid').setText(formData.feeDaysValid);
    
    form.getTextField('signatureName').setText(formData.signatureName);
    form.getTextField('signatureDate').setText(formData.signatureDate);

    // 5. Save the PDF
    const pdfBytes = await pdfDoc.save();

    // 6. Trigger download in browser
    const blob = new Blob([pdfBytes], { type: 'application/pdf' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = `Referral-${formData.consumerNames}.pdf`;
    link.click();

    //7. Email form to Delta Group Inc.
    const blobEmail = new Blob([pdfBytes], { type: 'application/pdf' });

    const reader = new FileReader();
    reader.readAsDataURL(blobEmail);
    reader.onloadend = async () => {
      const base64data = reader.result.split(',')[1]; // remove the "data:application/pdf;base64," prefix
    
      // Send email via EmailJS
      const templateParams = {
        from_name: fullName,
        to_name: 'Receiving Broker',
        message: 'New Referral PDF submitted',
        attachments: base64data
      };
    
      try {
        await emailjs.send(
          'service_58m64j5',
          'template_dj2taka',
          templateParams,
          'hAJmqdyYf07E3qAtY'
        );
        setSuccessMsg('Referral PDF emailed successfully!');
      } catch (err) {
        console.error(err);
        setErrors('Something went wrong while emailing the PDF.');
      } finally {
        setLoading(false);
      }
    };

    setSuccessMsg('Referral PDF generated successfully!');
  } catch (err) {
    console.error(err);
    setErrors('Something went wrong while creating the PDF.');
  }

  setLoading(false);
};


  return (
    <div className="referral-container">
      <h1>Referral Form</h1>
      <form onSubmit={handleSubmit}>
        
        <h2 className="referral-header-space">BROKER INFORMATION</h2>
        <div className="broker-sections">
          <div className="broker-column">
            <h3>Sending Broker</h3>
            <input name="sendingBrokerName" placeholder="Name" value={formData.sendingBrokerName} onChange={handleFormChange} />
            <input name="sendingBrokerLicense" placeholder="Broker's License #" value={formData.sendingBrokerLicense} onChange={handleFormChange} />
            <input name="sendingBrokerSalesperson" placeholder="Salesperson" value={formData.sendingBrokerSalesperson} onChange={handleFormChange} />
            <input name="sendingBrokerOffice" placeholder="Office" value={formData.sendingBrokerOffice} onChange={handleFormChange} />
            <input name="sendingBrokerAddress" placeholder="Address" value={formData.sendingBrokerAddress} onChange={handleFormChange} />
            <div className="referral-row">
              <input name="sendingBrokerCity" placeholder="City" value={formData.sendingBrokerCity} onChange={handleFormChange} />
              <input name="sendingBrokerState" placeholder="State" value={formData.sendingBrokerState} onChange={handleFormChange} />
              <input name="sendingBrokerZip" placeholder="Zipcode" value={formData.sendingBrokerZip} onChange={handleFormChange} />
            </div>           
            <input name="sendingBrokerOfficePhone" placeholder="Office Phone" value={formData.sendingBrokerOfficePhone} onChange={handleFormChange} />
            <input name="sendingBrokerCellPhone" placeholder="Cell Phone" value={formData.sendingBrokerCellPhone} onChange={handleFormChange} />
            <input name="sendingBrokerFax" placeholder="Fax" value={formData.sendingBrokerFax} onChange={handleFormChange} />
            <input name="sendingBrokerEmail" placeholder="Email" value={formData.sendingBrokerEmail} onChange={handleFormChange} />
            <input name="sendingBrokerContactMethod" placeholder="Preferred method of contact" value={formData.sendingBrokerContactMethod} onChange={handleFormChange} />
            <input name="sendingBrokerTaxID" placeholder="Federal Tax IDN (EIN or SSN, if sole proprietor)" value={formData.sendingBrokerTaxID} onChange={handleFormChange} />
          </div>

          <div className="broker-column">
            <h3>Receiving Broker</h3>
            <input name="receivingBrokerName" placeholder="Name" value={formData.receivingBrokerName} onChange={handleFormChange} />
            <input name="receivingBrokerLicense" placeholder="Broker's License #" value={formData.receivingBrokerLicense} onChange={handleFormChange} />
            <input name="receivingBrokerSalesperson" placeholder="Salesperson" value={formData.receivingBrokerSalesperson} onChange={handleFormChange} />
            <input name="receivingBrokerOffice" placeholder="Office" value={formData.receivingBrokerOffice} onChange={handleFormChange} />
            <input name="receivingBrokerAddress" placeholder="Address" value={formData.receivingBrokerAddress} onChange={handleFormChange} />
            <div className="referral-row">
              <input name="receivingBrokerCity" placeholder="City" value={formData.receivingBrokerCity} onChange={handleFormChange} />
              <input name="receivingBrokerState" placeholder="State" value={formData.receivingBrokerState} onChange={handleFormChange} />
              <input name="receivingBrokerZip" placeholder="Zipcode" value={formData.receivingBrokerZip} onChange={handleFormChange} />
            </div>
            <input name="receivingBrokerOfficePhone" placeholder="Office Phone" value={formData.receivingBrokerOfficePhone} onChange={handleFormChange} />
            <input name="receivingBrokerCellPhone" placeholder="Cell Phone" value={formData.receivingBrokerCellPhone} onChange={handleFormChange} />
            <input name="receivingBrokerFax" placeholder="Fax" value={formData.receivingBrokerFax} onChange={handleFormChange} />
            <input name="receivingBrokerEmail" placeholder="Email" value={formData.receivingBrokerEmail} onChange={handleFormChange} />
            <input name="receivingBrokerContactMethod" placeholder="Preferred method of contact" value={formData.receivingBrokerContactMethod} onChange={handleFormChange} />
            <input name="receivingBrokerDesignation" placeholder="Salesperson's Designation(s)" value={formData.receivingBrokerDesignation} onChange={handleFormChange} />
          </div>
        </div>

        {/* CONSUMER SECTION */}
        <h2 className="referral-header-space">CONSUMER INFORMATION</h2>
        <div className="broker-sections">
          <div className="broker-column">
            <input name="consumerNames" placeholder="Name(s)" value={formData.consumerNames} onChange={handleFormChange} />
            <input name="consumerAddress" placeholder="Address" value={formData.consumerAddress} onChange={handleFormChange} />
            <div className="referral-row">
              <input name="consumerCity" placeholder="City" value={formData.consumerCity} onChange={handleFormChange} />
              <input name="consumerState" placeholder="State" value={formData.consumerState} onChange={handleFormChange} />
              <input name="consumerZip" placeholder="Zipcode" value={formData.consumerZip} onChange={handleFormChange} />
            </div>
            <input name="consumerHomePhone" placeholder="Home Phone" value={formData.consumerHomePhone} onChange={handleFormChange} />
            <input name="consumerWorkPhone" placeholder="Work Phone" value={formData.consumerWorkPhone} onChange={handleFormChange} />
            <input name="consumerCellPhone" placeholder="Cell Phone" value={formData.consumerCellPhone} onChange={handleFormChange} />
          </div>

          <div className="broker-column">
            <input name="consumerEmail" placeholder="Email" value={formData.consumerEmail} onChange={handleFormChange} />
            <input name="consumerContactMethod" placeholder="Preferred method of contact" value={formData.consumerContactMethod} onChange={handleFormChange} />
            <label>If selling or leasing, address of property for sale/lease:</label>
            <input name="propertyAddress" placeholder="Address" value={formData.propertyAddress} onChange={handleFormChange} />
            <div className="referral-row">
              <input name="propertyCity" placeholder="City" value={formData.propertyCity} onChange={handleFormChange} />
              <input name="propertyState" placeholder="State" value={formData.propertyState} onChange={handleFormChange} />
              <input name="propertyZip" placeholder="Zip" value={formData.propertyZip} onChange={handleFormChange} />
            </div>
          </div>
        </div>

        <div className="checkbox-group">
          <label>
            <input type="checkbox" name="consumerPermissionYes" checked={formData.consumerPermissionYes === true} onChange={handleFormChange} />
            Consumer has given permission for Receiving Broker to contact Consumer.
          </label>
        </div>
        <div className="checkbox-group">
          <label>
            <input type="checkbox" name="consumerPermissionNo" checked={formData.consumerPermissionNo === true} onChange={handleFormChange} />
            Consumer has not given permission for Receiving Broker to contact Consumer and Consumer will initiate contact.
          </label>
        </div>

        <div className="checkbox-group">
          <label>Consumer is being referred only for:</label>
          <label><input type="checkbox" name="referralTypeListing" checked={formData.referralTypeListing} onChange={handleFormChange} /> <span>Listing</span></label>
          <label><input type="checkbox" name="referralTypePurchase" checked={formData.referralTypePurchase} onChange={handleFormChange} /> <span>Purchase</span></label>
          <label><input type="checkbox" name="referralTypeLeasing" checked={formData.referralTypeLeasing} onChange={handleFormChange} /> <span>Leasing</span></label>
          <label className="referral-other">
            <input type="checkbox" name="referralTypeOther" checked={formData.referralTypeOther} onChange={handleFormChange} /> <span>Other:</span>
            <input name="referralTypeOtherText" value={formData.referralTypeOtherText} onChange={handleFormChange} />
          </label>
        </div>

        <h2 className="referral-header-space">FEE AGREEMENT</h2>
        <p>In consideration of the referral of Consumer, Receiving Broker will pay a Referral Fee to Sending Broker as indicated below:</p>

        <div className="checkbox-group">
          <label className="fee-label">
            <input type="checkbox" name="feeAgreementListing" checked={formData.feeAgreementListing === true} onChange={handleFormChange} />
            <input className="fee-input-percent" name="feeListingPercent" value={formData.feeListingPercent} onChange={handleFormChange} /> % &nbsp;&nbsp;or&nbsp;&nbsp; $
            <input className="fee-input-dollar" name="feeListingDollar" value={formData.feeListingDollar} onChange={handleFormChange} /> of the Fee received by Receiving Broker for the listing side of Consumer's transaction.
          </label>
        </div>

        <div className="checkbox-group">
          <label className="fee-label">
            <input type="checkbox" name="feeAgreementPurchase" checked={formData.feeAgreementPurchase === true} onChange={handleFormChange} />
            <input className="fee-input-percent" name="feePurchasePercent" value={formData.feePurchasePercent} onChange={handleFormChange} /> %&nbsp;&nbsp; or &nbsp;&nbsp;$
            <input className="fee-input-dollar" name="feePurchaseDollar" value={formData.feePurchaseDollar} onChange={handleFormChange} /> of the Fee received by Receiving Broker for the purchase side of Consumer's transaction.
          </label>
        </div>

        <div className="checkbox-group">
          <label className="fee-label">
            <input type="checkbox" name="feeAgreementLeaseOfConsumer" checked={formData.feeAgreementLeaseOfConsumer === true} onChange={handleFormChange} />
            <input className="fee-input-percent" name="feeLeasePropertyPercent" value={formData.feeLeasePropertyPercent} onChange={handleFormChange} /> %&nbsp;&nbsp; or&nbsp;&nbsp; $
            <input className="fee-input-dollar" name="feeLeasePropertyDollar" value={formData.feeLeasePropertyDollar} onChange={handleFormChange} /> of the Fee received by Receiving Broker for the lease of Consumer's property.
          </label>
        </div>

        <div className="checkbox-group">
          <label className="fee-label">
            <input type="checkbox" name="feeAgreementLeaseByConsumer" checked={formData.feeAgreementLeaseByConsumer === true} onChange={handleFormChange} />
            <input className="fee-input-percent" name="feeLeaseByConsumerPercent" value={formData.feeLeaseByConsumerPercent} onChange={handleFormChange} /> % &nbsp;&nbsp;or &nbsp;&nbsp;$
            <input className="fee-input-dollar" name="feeLeaseByConsumerDollar" value={formData.feeLeaseByConsumerDollar} onChange={handleFormChange} /> of the Fee received by Receiving Broker for the lease of property by Consumer.
          </label>
        </div>

        <div className="checkbox-group">
          <label className="fee-label">
            <input type="checkbox" name="feeAgreementOther" checked={formData.feeAgreementOther === true} onChange={handleFormChange} /> Other: &nbsp;&nbsp;
            <input className="fee-other" name="feeAgreementOtherText" value={formData.feeAgreementOtherText} onChange={handleFormChange} />
          </label>
        </div>

        <div>
          <label className="fee-label">
            <span>The Referral Fee will be paid to the Sending Broker within</span>
            <input className="fee-input-percent" name="feeDaysToPay" value={formData.feeDaysToPay} onChange={handleFormChange} />
            <span>&nbsp;&nbsp;days of Receiving Broker's receipt of its fee.</span>
          </label>
        </div>

        <div>
          <label className="fee-label">
            <span>Referral Fee is due to Sending Broker for any transaction(s) selected above that is executed within</span>
            <input className="fee-input-percent" name="feeDaysValid" value={formData.feeDaysValid} onChange={handleFormChange} />
            <span>&nbsp;&nbsp;days of the acceptance of this Referral Agreement.</span>
          </label>
        </div>

        <div>
          <label className="fee-label-bold">
            <span>By typing your name into this box below, Licensee agrees that this electronic entry constitutes his/her signature and that he/she is authorized by Broker to accept this referral Agreement.</span>
          </label>
        </div>

        <div>
          <label className="fee-label-bold">
            <span className="referral-signature-words">Type name for Electronic Signature:&nbsp;&nbsp;</span>
            <input className="referral-signature-box" name="signatureName" value={formData.signatureName} onChange={handleFormChange} />
            <span className="referral-signature-words">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Date Signed:</span>
            <input className="referral-signature-date" name="signatureDate" value={formData.signatureDate} onChange={handleFormChange} />
          </label>
        </div>

        <button type="submit" disabled={loading}>
          {loading ? 'Submitting...' : 'Submit Referral'}
        </button>

        {errors && <div className="referral-error">{errors}</div>}
        {successMsg && <div className="referral-success">{successMsg}</div>}
      </form>
    </div>
  );
};

export default Referral;
